module.exports = __webpack_public_path__ + "static/media/hi-banner-image.651657a3.svg";